import { render, staticRenderFns } from "./lei-do-bem.vue?vue&type=template&id=37b71731&scoped=true&"
import script from "./lei-do-bem.vue?vue&type=script&lang=js&"
export * from "./lei-do-bem.vue?vue&type=script&lang=js&"
import style0 from "./lei-do-bem.vue?vue&type=style&index=0&id=37b71731&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b71731",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
